import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataserviceService } from '../dataservice.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-portals',
  templateUrl: './portals.component.html',
  styleUrl: './portals.component.css'
})
export class PortalsComponent implements OnInit {
  companies: any[] = [];
  selectedCompanyId: string | null = null;
  currentUser: any;

  constructor(private router: Router,
    private data: DataserviceService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
  }

  ngOnInit() {
    this.getPortals()
  }

  async getPortals() {
    try {
      const user = await firstValueFrom(this.data.getUser());

      if (user && (user as any).portals) {
        this.companies = (user as any).portals;
      } else {
        this.companies = [];
      }
    } catch (error) {
      console.error('Error fetching portals:', error);
      this.companies = [];
    }
  }

  async onCompanyClick(portal: any) {
    this.selectedCompanyId = portal.id;
    await this.navigate(portal);
  }

  async navigate(portal: any) {
    const user = this.currentUser;
    if (!user || !portal) return;

    this.data.getData(`portals/selected-portal/${portal.id}`)
      .subscribe(({
        next: async (res: any) => {
          localStorage.removeItem('user')
          const updatedUser = {
            ...user,
            ...res,
            id: user.id,
            active_portal_id: portal.id,
            active_company_name: portal.company?.name || 'Unknown'
          };

          localStorage.setItem('user', JSON.stringify(updatedUser));
          this.currentUser = updatedUser;

          const targetRoute = portal.onboardingCompleted ? '/home' : '/onboarding';
          await this.router.navigate([targetRoute]);
        }}))
  }
}
